import React, { useState, useEffect } from 'react'
import { Layout, Grid } from 'antd'
import MenuItems from './MenuItems'

const { Content, Sider } = Layout
const { useBreakpoint } = Grid

const Menu: React.FC = ({ children }) => {
  const { lg } = useBreakpoint()
  const isMobile = lg === false
  const [ menuVisible, setMenuVisible ] = useState(false)
  const [ showMenu , setShowMenu ] = useState(true);

  useEffect(() => {
    const handleResize = () => {
        setShowMenu( (window.innerWidth > 991) );
    };

    window.addEventListener('resize', handleResize);
    handleResize()

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <>
      <Layout className="global-layout">
      { showMenu && (
        <Sider
          breakpoint="lg"
          collapsedWidth="60"
          width="200"
          style={{
            overflow: 'auto',
            height: '100vh',
            position: 'fixed',
            left: 0,
            top: 64,
            paddingTop: 16,
            paddingBottom: 16,
          }}
        >
          <MenuItems setMenuVisible={setMenuVisible} />
        </Sider>
      )}
        <Layout style={{ marginLeft: isMobile ? 0 : 200, marginTop: 64 }}>
          <Content
            style={{
              padding: 24,
              margin: 0,
              minHeight: 'calc(100vh - 88px)',
            }}
          >
            {children}
          </Content>
        </Layout>
      </Layout>
    </>
  )
}

export default Menu
